import './index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import classnames from 'classnames';
import { useDisabled } from '@hh.ru/magritte-common-use-disabled';
import { DEFAULT_SIZE } from './types.js';
import { s as styles } from './badge-Cka7SRap.js';

const Badge = forwardRef(({ children, size = DEFAULT_SIZE, style = 'attention', 'data-qa': dataQA = 'badge' }, ref) => {
    const disabled = useDisabled();
    return (jsx("span", { className: classnames(styles.badge, {
            [styles[`badge_size-${size}`]]: size,
            [styles[`badge_${style}`]]: style,
            [styles.badge_disabled]: !!disabled,
        }), "data-qa": dataQA, ref: ref, children: size !== 'extra-small' && children?.slice(0, 10) }));
});
Badge.displayName = 'Badge';

export { Badge };
//# sourceMappingURL=Badge.js.map
